import { render, staticRenderFns } from "./cooperation_list_add.vue?vue&type=template&id=219f8648&scoped=true&"
import script from "./cooperation_list_add.vue?vue&type=script&lang=js&"
export * from "./cooperation_list_add.vue?vue&type=script&lang=js&"
import style0 from "./cooperation_list_add.vue?vue&type=style&index=0&id=219f8648&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f8648",
  null
  
)

export default component.exports